export class AuthMapper {
  static mapToLoginRequestJson (data) {
    console.log('login AuthMapper', data);
    const request = {
      'email': data.email,
      'password': data.password,
    }
    return request;
  }
  static mapToToken (response) {
    const token = {
      accessToken: response.token,
      refreshToken: response.token,
    }
    return token;
  }
  static mapToRegisterRequestJson (data) {
    const request = {
      'fullname': data.fullName,
      'login': data.login,
      'password': data.password,
    }
    return request;
  }
}
